module.exports = __webpack_public_path__ + "img/img6.304ce498.png";